import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PlanNumberRevealService {
  private readonly isPlanNumberRevealedSubject = new BehaviorSubject<boolean>(
    false
  );

  readonly isPlanNumberRevealed$ =
    this.isPlanNumberRevealedSubject.asObservable();

  getIsPlanNumberRevealed(): boolean {
    return this.isPlanNumberRevealedSubject.value;
  }

  setIsPlanNumberRevealed(isRevealed: boolean): void {
    this.isPlanNumberRevealedSubject.next(isRevealed);
  }
}
